import React, { ReactNode } from 'react';
type ButtonProps = {
  href: string;
  children: ReactNode;
  variant?: 'gold' | 'teal';
  size?: 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
};
const variants = {
  gold: 'bg-gold text-navy shadow-[0_6px_0_#C9962F,0_14px_28px_rgba(237,190,89,0.32)] hover:bg-gold-hover active:shadow-[0_1px_0_#C9962F]',
  teal: 'bg-teal text-white shadow-[0_6px_0_#185F5C,0_14px_28px_rgba(35,123,119,0.22)] hover:bg-teal-hover active:shadow-[0_1px_0_#185F5C]'
};
const sizes = {
  lg: 'min-h-[62px] px-7 text-lg sm:text-[20px]',
  xl: 'min-h-[74px] w-full px-6 text-xl sm:text-[23px]'
};
export function Button({
  href,
  children,
  variant = 'gold',
  size = 'lg',
  className = '',
  onClick
}: ButtonProps) {
  return <a href={href} onClick={onClick} className={`inline-flex items-center justify-center gap-3 rounded-2xl text-center font-bold uppercase leading-tight tracking-[0.01em] no-underline transition-[background-color,transform,box-shadow] duration-150 ease-out active:translate-y-[5px] ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-18" data-mp="23ajnwhibsrr2">
      {children}
    </a>;
}